import { AU_TAX_RATE, DE_TAX_RATE, UK_TAX_RATE } from 'constants/taxRates'
import { useMemo } from 'react'

type Taxation = {
  taxRate: number
  taxName: string
}

export const useTaxation: (countryCode: string | undefined) => Taxation = (countryCode) =>
  useMemo(() => {
    if (!countryCode) {
      return { taxRate: 0, taxName: '' }
    }
    switch (countryCode.toUpperCase()) {
      case 'AU':
        return { taxRate: AU_TAX_RATE, taxName: 'GST' }
      case 'GB':
        return { taxRate: UK_TAX_RATE, taxName: 'VAT' }
      case 'DE':
        return { taxRate: DE_TAX_RATE, taxName: 'VAT' }
      default:
        return { taxRate: 0, taxName: '' }
    }
  }, [countryCode])
